import { c as _c } from "react/compiler-runtime";
import { Dialog, Transition } from "@headlessui/react";
import type { ReactNode } from "react";
import { Fragment } from "react";
export default function SeasonsGridDropdownMobileWrapper(t0) {
  const $ = _c(23);
  const {
    isOpen,
    setOpen,
    label,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Transition.Child as={Fragment} enter="tw-ease-in-out tw-duration-300" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-ease-in-out tw-duration-300" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-transition-opacity" /></Transition.Child>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setOpen) {
    t2 = () => setOpen(false);
    $[1] = setOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="tw-w-6 tw-h-6 tw-flex-shrink-0 tw-text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Transition.Child as={Fragment} enter="tw-ease-in-out tw-duration-300" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-ease-in-out tw-duration-300" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-absolute tw-right-0 -tw-top-16 -tw-ml-8 tw-flex tw-pr-2 tw-pt-4 sm:-tw-ml-10 sm:tw-pr-4"><button type="button" title="Close panel" aria-label="Close panel" className="tw-p-2.5 tw-relative tw-bg-transparent tw-rounded-md focus:tw-outline-none tw-border-none focus:tw-ring-2 focus:tw-ring-white" onClick={t2}>{t3}</button></div></Transition.Child>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      maxHeight: "calc(100vh - 8rem)"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = label && <div className="tw-px-6"><Dialog.Title className="tw-text-base tw-font-semibold tw-text-iron-50">{label}</Dialog.Title></div>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== children) {
    t7 = <div className="tw-relative tw-mt-3 tw-flex-1 tw-px-4 sm:tw-px-6 tw-gap-y-6 tw-flex tw-flex-col tw-pb-[env(safe-area-inset-bottom,0px)]"><div className="tw-grid tw-grid-cols-4 tw-gap-3">{children}</div></div>;
    $[9] = children;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-bg-iron-950 tw-rounded-t-xl tw-overflow-y-auto tw-scroll-py-3 tw-pt-6" style={t5}>{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t8) {
    t9 = <div className="tw-fixed tw-inset-0 tw-overflow-hidden"><div className="tw-absolute tw-inset-0 tw-overflow-hidden"><div className="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-max-w-full tw-pt-10"><Transition.Child as={Fragment} enter="tw-transform tw-transition tw-ease-out tw-duration-300" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-ease-in tw-duration-300" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><Dialog.Panel className="tw-pointer-events-auto tw-relative tw-w-screen">{t4}{t8}</Dialog.Panel></Transition.Child></div></div></div>;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== setOpen || $[18] !== t9) {
    t10 = <Dialog as="div" className="tailwind-scope tw-z-[1000] tw-absolute lg:tw-hidden" onClose={setOpen}>{t1}{t9}</Dialog>;
    $[17] = setOpen;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== isOpen || $[21] !== t10) {
    t11 = <Transition.Root show={isOpen} as={Fragment}>{t10}</Transition.Root>;
    $[20] = isOpen;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}